module.exports = __webpack_public_path__ + "static/media/leaseIcon.10e15154.svg";